import { Button } from '@codegouvfr/react-dsfr/Button';
import { useTextes } from '@common/config';
import { useSessionContext } from '@common/hooks';
import { EtablissementCardDto, EtablissementProjection, useGetOrganismeEtablissementsQuery } from '@common/services';
import { FcPaginator } from '@common/ui';
import { EtablissementCard, ETABLISSEMENTS_TRIE_DEFAUT } from '@common/ui/etablissement';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store.hook';
import {
  needNewDeclaration,
  resetRncpModified
} from '../../../Dashboard/components/VerticalStepper/stores/dashboard-stepper.slice';
import { EtablissementBottomInfoCard } from './components/EtablissementBottomInfoCard';

export const RncpEtablissementsList = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const t = useTextes('ParcoursOfa', 'EtapierStep3');
  const { organismeId } = useSessionContext();

  const [page, setPage] = useState<number>(0);;

  const hasModifiedRncps = useAppSelector((state) => state.dashboardStepperSlice.hasModifiedRncps);

  const { data: pageEtablissementDeclarants, isLoading } = useGetOrganismeEtablissementsQuery({
    id: organismeId,
    projection: EtablissementProjection.CARD,
    page,
    size: 5,
    sorters: ETABLISSEMENTS_TRIE_DEFAUT,
    filters: { declarant: true },
  }, { refetchOnMountOrArgChange: true });

  if (isLoading) return null;

  const handleFinish = () => {
    if (hasModifiedRncps) {
      dispatch(needNewDeclaration());
    }
    dispatch(resetRncpModified());
    navigate('/tableau-de-bord');
  };

  return (
    <div className={'flex flex-col gap-4 items-center p-4 pb-8'}>

      <div className={'flex flex-col w-full max-w-[1200px]'}>
        <div className={'flex items-center'}>
          <h3 className={'flex-1 !mb-1'}>{t['ETAB_RNCP_TEXTE1']}</h3>
        </div>
        <span className={'mt-4'}>{t['ETAB_RNCP_TEXTE2']}</span>
      </div>

      <div className={'w-full flex flex-col max-w-[1200px] py-[56px] px-[102px] bg-white gap-8'}>

        <h4 style={{ margin: 0 }}
            className={'pb-4 border-b-1 border-[#DDDDDD]'}>{t['ETAB_RNCP_TEXTE3']}</h4>

        {pageEtablissementDeclarants.content.map((etablissement: EtablissementCardDto, index) => (
          <div key={index}>
            <EtablissementCard etablissement={etablissement}
                               bottomCardJsx={(
                                 <EtablissementBottomInfoCard etablissementId={etablissement.id}
                                                              rncpsCount={etablissement.rncpsCount} />
                               )} />
          </div>
        ))}

        {(pageEtablissementDeclarants?.totalPages > 1) && (
          <div className={'flex flex-col items-center'}>
            <FcPaginator page={pageEtablissementDeclarants?.pageable.pageNumber ?? 0}
                         totalPages={pageEtablissementDeclarants?.totalPages ?? 0}
                         onPageChange={setPage} />
          </div>
        )}

        <div className={'flex justify-end gap-2'}>
          <Button onClick={handleFinish}>VALIDER</Button>
        </div>
      </div>
    </div>
  );
};